export function getInitials(name: string): string {
  // split the name into words, ignoring extra spaces.
  const words: string[] = name.split(' ').filter((word) => word.length > 0);

  // if no valid words are provided, return an empty string.
  if (words.length === 0) return '';

  // if there's only one word, return the first two characters.
  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }

  const firstInitial: string = words[0][0];
  const lastInitial: string = words[words.length - 1][0];
  return (firstInitial + lastInitial).toUpperCase();
}
